import { Flex } from '@chakra-ui/react';
import React, { useEffect } from 'react';
import { render } from 'storyblok-rich-text-react-renderer';

import { TitleAndContent as TitleAndContentStoryblok } from '@/.storyblok/types/225909/storyblok-components';

import './TitleAndContent.scss';

interface TitleAndContentProps {
  blok: TitleAndContentStoryblok;
}

const TitleAndContent = ({ blok }: TitleAndContentProps) => {
  const alignment = blok.Alignment;

  //////////////////////////////
  // Lazy Load Images within rich text content
  //////////////////////////////

  useEffect(() => {
    const images = document.querySelectorAll('.content-container img');
    images.forEach(img => {
      img.setAttribute('loading', 'lazy');
    });
  }, []);

  return (
    <Flex className={`title-and-content-container ${alignment}`}>
      {blok.Title && (
        <Flex className={'title-container'}>
          <h3 className={`title`}>{blok.Title}</h3>
        </Flex>
      )}
      <Flex className={`content-container`}>{render(blok.Content)}</Flex>
    </Flex>
  );
};

export default TitleAndContent;
